import { Grid, Skeleton, styled } from '@mui/material'

export const WidgetToolbarSkeleton = () => {
  return (
    <StyledContainer container direction={'row'} justifyContent="flex-start" alignItems="center">
      {Array.from(new Array(5)).map((_, index) => (
        <Grid item key={index}>
          <StyledButtonSkeleton animation="wave"  variant="rectangular" width={48} height={32} />
        </Grid>
      ))}
    </StyledContainer>
  )
}

const StyledContainer = styled(Grid)`
  height: ${({ theme }) => theme.typography.pxToRem(48)};
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: ${({ theme }) => theme.typography.pxToRem(8)};
  border-radius: ${({ theme }) => theme.typography.pxToRem(8)};
  margin: 0 ${({ theme }) => theme.typography.pxToRem(8)};
  width: calc(100% - ${({ theme }) => theme.typography.pxToRem(16)});
`

const StyledButtonSkeleton = styled(Skeleton)`
  box-shadow: ${({ theme }) => theme.palette.custom.widgetButton.boxShadow};
  border-radius: ${({ theme }) => theme.typography.pxToRem(4)};
  width: ${({ theme }) => theme.typography.pxToRem(48)};
  height: ${({ theme }) => theme.typography.pxToRem(32)};
  margin-right: ${({ theme }) => theme.typography.pxToRem(8)};
`